// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"420":"b604fbcd","453":"01509c53","535":"a0068ed8","931":"e46bac22"}[chunkId] + ".chunk.js";
};